import './devbx.webform.page.css'

BX.addCustomEvent("DevBxWebFormCreated", function(app) {
    app.component('devbx-webform-page', {
        props: ['page', 'isActive', 'disableActions'],
        data() {
            return {
                rows: [],
            }
        },
        computed: {
            isLoading() {
                let loading = false;

                this.page.getAllFormFields().forEach(item => {
                    if (item.component && item.component.isLoading)
                        loading = true;
                });

                return loading;
            },

            pageIsBusy() {
                let isBusy = false;

                this.page.getAllFormFields().forEach(item => {
                    //не прерывать цикл, что бы vue отслеживал изменения
                    if (item.component && typeof item.component.fieldIsBusy === 'function')
                    {
                        if (item.component.fieldIsBusy())
                            isBusy = true;
                    }
                });

                return isBusy;
            },

            cssClass()
            {
                let result = {};

                result['devbx-webform-page-active'] = this.isActive;

                if (this.page.config.cssClass.length)
                {
                    result[this.page.config.cssClass] = true;
                }

                return result;
            },
        },
        directives: {
            row: {
                inserted(el, binding, vnode) {
                    vnode.componentInstance.$parent.rows.push(vnode.componentInstance);
                },

                unbind(el, binding, vnode) {
                    let idx = vnode.componentInstance.$parent.rows.indexOf(vnode.componentInstance);

                    if (idx >= 0)
                        vnode.componentInstance.$parent.rows.splice(idx, 1);
                }
            },
        },
        template: `
            <div class="devbx-webform-page" :class="cssClass">
                    <devbx-webform-form-row ref="rows" v-row v-for="(row, index) in page.items" :key="row.id" v-bind:row="row"/>
                    <devbx-webform-form-page-actions 
                        :page="page" 
                        :form-page-actions="$root.webForm.pageActions" 
                        :disable-actions="disableActions || pageIsBusy"
                    @submit-form="$emit('submit-form')"
                    ></devbx-webform-form-page-actions>
                    <div v-if="isLoading" class="devbx-webform-page-loading">
                        <div class="devbx-webform-page-lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>                    
                    </div>
            </div>
    `
    });
});